/** App-wide tooltip look: dark rounded card with a soft shadow. Used by the
 *  MUI v5 theme in index.js (and re-applied by pages that create their own
 *  theme), and by the hand-positioned hover card of the 3D gamut plot. */
const TOOLTIP_BG = "rgba(17, 24, 39, 0.96)";
const TOOLTIP_TEXT = "#f3f4f6";
export const TOOLTIP_MUTED = "rgba(255, 255, 255, 0.55)";

export const tooltipCardSx = {
    bgcolor: TOOLTIP_BG,
    color: TOOLTIP_TEXT,
    borderRadius: 2,
    p: 1.5,
    maxWidth: 360,
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 1.4,
    boxShadow: "0 12px 32px rgba(0, 0, 0, 0.35)",
    border: "1px solid rgba(255, 255, 255, 0.08)",
};

/** `components` block for createTheme(). */
export const tooltipThemeComponents = {
    MuiTooltip: {
        // Non-interactive: the card never catches the pointer, so moving onto
        // the element behind it (e.g. the grid cell above) switches the card.
        defaultProps: { arrow: true, enterDelay: 150, disableInteractive: true },
        styleOverrides: {
            tooltip: {
                backgroundColor: TOOLTIP_BG,
                color: TOOLTIP_TEXT,
                borderRadius: 10,
                padding: "10px 12px",
                maxWidth: 360,
                fontSize: 12,
                fontWeight: 400,
                lineHeight: 1.4,
                boxShadow: "0 12px 32px rgba(0, 0, 0, 0.35)",
                border: "1px solid rgba(255, 255, 255, 0.08)",
            },
            arrow: { color: TOOLTIP_BG },
        },
    },
};
